var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChalk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.869 -.495 .495 .869 -154.488 145.501)",
    gradientUnits: "userSpaceOnUse",
    x1: 135.758,
    x2: 343.724,
    xlinkHref: "#lg1",
    y1: 229.459,
    y2: 437.425
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.869 -.495 .495 .869 -154.488 145.501)",
    gradientUnits: "userSpaceOnUse",
    x1: 342.189,
    x2: 135.371,
    xlinkHref: "#lg1",
    y1: 401.794,
    y2: 194.977
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9100"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.869 -.495 .495 .869 -154.488 145.501)",
    gradientUnits: "userSpaceOnUse",
    x1: 256.19,
    x2: 256.19,
    xlinkHref: "#lg2",
    y1: 390.533,
    y2: 491.32
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.454,
    x2: 250.732,
    xlinkHref: "#lg2",
    y1: 466.376,
    y2: 376.016
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2187,
    stopColor: "#b6d600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#acc900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#9ab400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    stopColor: "#829700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.964 .267 -.267 .964 75.625 -60.768)",
    gradientUnits: "userSpaceOnUse",
    x1: 196.423,
    x2: 404.389,
    xlinkHref: "#lg3",
    y1: 145.273,
    y2: 353.239
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.964 .267 -.267 .964 75.625 -60.768)",
    gradientUnits: "userSpaceOnUse",
    x1: 402.854,
    x2: 196.036,
    xlinkHref: "#lg3",
    y1: 317.608,
    y2: 110.79
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.964 .267 -.267 .964 75.625 -60.768)",
    gradientUnits: "userSpaceOnUse",
    x1: 316.855,
    x2: 316.855,
    xlinkHref: "#lg4",
    y1: 306.347,
    y2: 407.134
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.394,
    x2: 69.806,
    xlinkHref: "#lg4",
    y1: 326.781,
    y2: 145.717
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.313,
    x2: 302.278,
    xlinkHref: "#lg5",
    y1: 136.101,
    y2: 344.066
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.743,
    x2: 93.926,
    xlinkHref: "#lg5",
    y1: 308.435,
    y2: 101.618
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.745,
    x2: 214.745,
    y1: 297.174,
    y2: 397.961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m306.5 437.452c-40.019 22.781-81.423 43.201-123.88 61.116-54.428 22.966-115.613-13.856-120.484-72.73-3.536-42.738-4.402-85.697-2.575-128.54 1.9-44.546 6.714-88.97 14.381-132.895 9.382-53.753 65.482-85.689 116.492-66.314 41.684 15.832 82.341 34.372 121.615 55.478 37.772 20.3 74.269 42.976 109.214 67.835 48.138 34.244 48.565 105.653 1.031 140.73-37.08 27.36-75.774 52.538-115.794 75.32z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.385,
    cy: 293.202,
    fill: "url(#SVGID_2_)",
    r: 85.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.62 498.567c42.458-17.915 83.861-38.334 123.88-61.116 40.019-22.781 78.714-47.959 115.793-75.322 46.926-34.629 47.105-104.661.787-139.394l-360.723 205.348c6.22 57.558 66.531 93.157 120.263 70.484z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m422.291 362.133c-37.082 27.356-75.768 52.54-115.788 75.323-40.02 22.773-81.427 43.197-123.879 61.117-.155.062-.31.134-.466.186l-122.212-122.224s-.228.3-.662.869c-.952-26.694-.859-53.419.279-80.103 1.893-44.552 6.715-88.97 14.382-132.901 9.374-53.75 65.483-85.69 116.491-66.311 41.686 15.83 82.338 34.371 121.613 55.478 37.775 20.3 74.267 42.969 109.218 67.832 48.132 34.248 48.556 105.649 1.024 140.734z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m274.692 407.047c-44.374-12.307-88.049-27.262-130.693-44.73-54.667-22.393-71.709-91.74-33.402-136.712 27.807-32.647 57.654-63.557 89.318-92.474 32.923-30.067 67.814-57.983 104.363-83.524 44.726-31.256 106.932-14.003 129.169 35.825 18.172 40.719 33.699 82.618 46.431 125.348 12.245 41.096 21.907 82.964 28.926 125.27 9.669 58.279-40.658 108.941-99.049 99.976-45.55-6.993-90.689-16.671-135.063-28.979z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.054,
    cy: 247.101,
    fill: "url(#SVGID_6_)",
    r: 85.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.999 362.317c42.644 17.468 86.319 32.423 130.693 44.73s89.513 21.986 135.062 28.978c57.644 8.849 107.423-40.412 99.384-97.745l-399.978-110.935c-36.422 45.001-19.129 112.866 34.839 134.972z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m409.751 436.027c-45.545-6.994-90.687-16.668-135.063-28.98-44.366-12.302-88.049-27.263-130.687-44.728-54.671-22.39-71.712-91.742-33.409-136.719 27.811-32.643 57.661-63.548 89.321-92.467 30.822-28.153 63.372-54.412 97.392-78.613l192.693 192.693c7.574 29.312 13.844 58.965 18.8 88.835 9.675 58.283-40.651 108.94-99.047 99.979z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m214.745 388.422c-46.049 0-92.133-2.738-137.894-8.173-58.663-6.968-93.619-69.237-68.726-122.812 18.071-38.891 38.57-76.653 61.353-112.982 23.689-37.772 49.85-73.998 78.243-108.379 34.746-42.073 99.299-42.073 134.045 0 28.393 34.381 54.554 70.606 78.243 108.379 22.783 36.328 43.283 74.091 61.353 112.982 24.893 53.574-10.063 115.844-68.726 122.812-45.758 5.435-91.842 8.173-137.891 8.173z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.745,
    cy: 222.437,
    fill: "url(#SVGID_10_)",
    r: 85.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.851 380.248c45.761 5.435 91.844 8.173 137.894 8.173s92.133-2.738 137.894-8.173c57.913-6.879 92.714-67.653 69.645-120.751h-415.078c-23.069 53.099 11.733 113.872 69.645 120.751z",
    fill: "url(#SVGID_11_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChalk);
export default __webpack_public_path__ + "static/media/icon-chalk.6b1e7c1b691cf096aaf8060417b82fe3.svg";
export { ForwardRef as ReactComponent };